import type { Fields, MassActionRequest } from '@tribeplatform/gql-client/types'

import {
  useQuery,
  type UseQueryOptions,
} from '../../lib/react-query/useQuery.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getMassActionRequestInProgressKey } from '../../utils/keys/massAction.keys.js'

export const useMassActionRequestInProgress = (options?: {
  fields?: Fields.MassActionRequestFields
  useQueryOptions?: UseQueryOptions<MassActionRequest>
}) => {
  const { fields = 'basic', useQueryOptions } = options || {}
  const { client } = useTribeClient()
  const exportRequestKey = getMassActionRequestInProgressKey({ fields })

  return useQuery<MassActionRequest>(
    exportRequestKey,
    () =>
      client.query({
        name: 'massActionRequestInProgress',
        args: fields,
      }),
    useQueryOptions,
  )
}
